import { ISbStoryData } from 'storyblok-js-client';

import { getLocalePrefix } from '@monoimin/intl';

import { ARTICLE_SLUGS_BY_TYPE } from '@monoimin/constants';

import type { ArticleStoryblok, Locales } from '@monoimin/sb-types';

const getMinisiteSlugFromArticleFullSlug = (fullSlug: string) => {
  const choppedSlug = fullSlug.split('/');

  if (choppedSlug[0] === 'imin-minisites') {
    return choppedSlug[1];
  }

  return '';
};
const trailingSlash =
  process.env['NEXT_PUBLIC_TRAILING_SLASH'] === 'true' ? '/' : '';

export const getArticleUrl = (
  story: ISbStoryData<ArticleStoryblok>,
  locale: Locales
): string => {
  const { slug, content, full_slug } = story;

  const localePrefix = getLocalePrefix(locale);

  const siteName = getMinisiteSlugFromArticleFullSlug(full_slug);

  const articleSlug = ARTICLE_SLUGS_BY_TYPE[content.articleType];

  // Меняем url ссылки для статей кипра с /blog на /guides
  if (siteName === 'imin-cyprus' && articleSlug === 'blog') {
    return `${localePrefix}/guide/${slug}`;
  }

  return `${localePrefix}/${articleSlug}/${slug}${trailingSlash}`;
};

export default getArticleUrl;
